import script from "./base-avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-avatar.vue?vue&type=script&setup=true&lang=ts"

import "./base-avatar.vue?vue&type=style&index=0&id=03c70006&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03c70006"]])

export default __exports__